import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "reactstrap";
import { ApplicantActions } from "../../actions";
import recuiterSvg from "../../resources/images/status.svg"
import downArraow from '../../assets/images/down-arrow.svg'

import Select from "react-select";

const RecuterForm = (props) => {
  const [assigneeId, setAssigneeId] = useState(null);
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState("");
  const dispatch = useDispatch();
  const inputReference = useRef(null);

  useEffect(() => {
    if (props?.row?.recruiter?.id) {
      setAssigneeId(props?.row?.recruiter?.id);
    }
  }, [props?.row])

  const onChange = (val) => {
    setAssigneeId(val);
    ChangeStatus(val)
  };
  
  const ChangeStatus = (id) => {
    if (props?.row?.id) {
      dispatch(
        ApplicantActions.updateApplicant(
          { recruiterID: id },
          props?.row?.id
        )
      ).then((res) => {
        if (res) {
          dispatch(ApplicantActions.getApplicant(props?.row?.id))
        }
      });
    }
  };

  const assignee = useSelector((state) => state.jobProfiles.inetviewer);

  useEffect(() => {
    let merger = [];
    if (props?.editedData?.assigneeId && props?.editedData?.assigneeId !== "") {
      const [value, label] = [
        props?.editedData?.assigneeId?.split(","),
        props?.editedData?.assigneeNames?.split(","),
      ];
      merger = value?.map((node, index) => ({
        value: node,
        label: `${label[index]}`,
      }));
    }
    if (assignee?.length > 0) {
      const resVal = assignee?.map((val) => {
        return {
          value: val?.id,
          label: val?.name,
        };
      });
      let finalArr = resVal;
      if (merger && merger.length > 0) {
        finalArr.concat(merger);
      }
      finalArr.unshift({ value: "", label: "Select Recruiter" })

      setOptions([
        ...new Map(finalArr.map((item) => [item["value"], item])).values(),
      ]);
    } else {
      setOptions(merger);
    }
  }, [assignee]);

  const user = useSelector((state) => state.authentication.user);

  return (
    <>
      <Form>
        <div className="form-group recStatus">
          <img src={recuiterSvg} alt="Recruiter" className="recuiterImg" />
          <span className="RecruiterLabel">Recruiter</span>
          {user && Number(user?.userRole) !== 4 ?
            <Select
              options={options.filter(x => x.label.toLowerCase().includes(query.toLowerCase())).slice(0, 5)}
              name="assigneeId"
              id="assigneeId"
              ref={inputReference}
              className="commen-select-rec form-control"
              classNamePrefix="react-select"
              value={
                options ? options?.find((option) => option.value === assigneeId) : ""
              }
              onChange={(option) => onChange(option?.value)}
              placeholder={'Select Recruiter'}
              onInputChange={(value) => setQuery(value)}
              styles={{
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected ? "rgba(228, 156, 47, 0.12)" : "transparent",
                  borderRadius: '0.3rem',
                  color: "black"
                })
              }}
            />
            : <div className="recuterName">
              <span className="recName">{props?.row?.recruiter?.name}</span>
            </div>
          }
          {
            Number(user?.userRole) !== 4 ? (<img className="down-arrow-image" src={downArraow} alt="downArrow" />) : ("")
          }
        </div>
      </Form>
    </>
  );
};

export default RecuterForm;
